import ConvertUnitsForDisplay from "@Shared/Helpers/CalculateUsageCovered/ConvertUnitsForDisplay";
import CalculateUsageCovered from "@Shared/Helpers/CalculateUsageCovered/index";
const ukAllowanceTypes = new Set([
    "UK Data (GB)",
    "Std Calls (mins)",
    "Std SMS",
    "Biz rate Calls (mins)",
    "Prem Calls",
    "Prem SMS",
    "Std MMS",
    "Dir Enq",
    "Free Calls (mins)",
]);
export default (tender, proposal) => {
    const covered = CalculateUsageCovered(tender, proposal);
    let totalCost = 0;
    for (const allowanceType in covered) {
        const isUKAllowance = ukAllowanceTypes.has(allowanceType);
        if (tender.isSmallBusiness &&
            !tender.details.iddCost &&
            !isUKAllowance) {
            // skip IDD & Roaming costs
            continue;
        }
        totalCost += covered[allowanceType].costOfBundles;
        totalCost +=
            ConvertUnitsForDisplay(covered[allowanceType].remaining, allowanceType) * (proposal?.rackRate?.[allowanceType] || 0);
    }
    return totalCost;
};
